import { messages } from './HelpTooltip.messages';

export const helpItems = [messages.tooltipItem1, messages.tooltipItem2, messages.tooltipItem3];
